module.exports = __webpack_public_path__ + "static/023-9718dd64a89eee827b68610f446e1420.jpg";